module.exports = __webpack_public_path__ + "img/hzfp38.1ce8d127.png";